<template>
    <v-container id="home" class="fill-height">
        <v-snackbar
      v-model="snackbarVerify"
      :vertical="vertical"
      color="red"
      :timeout="10000" top
    >
      {{ text }}
      <v-btn
        color="white"
        text
        @click="snackbarVerify = false"
      >
        Close
      </v-btn>
    </v-snackbar>
        <v-dialog v-model="dialog" width="500" persistent>
            <v-card class="pa-10 mx-auto" id="login" max-width="500" elevation="7">
                <v-system-bar light color="#ffffff" class="mt-n5">
                    <v-spacer></v-spacer>
                    <v-btn icon to="/importwishlist">
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </v-system-bar>
                <div class="text-center mb-4" style="color:#1a00d4">Exceeded Offer Range</div>
                <v-card-text>
                    Hi <b>{{username}}</b>,<br>
                    You have exceeded your offer range which is: <strong> ${{minPrice}}-${{maxPrice}} </strong>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="text-right mt-12">
                        <v-btn rounded dark color="#1a00d4" :loading="loading" class="text-none ml-2"  to='/importwishlist'>
                            Import Wish List Again
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" top color="green" :timeout="10000">
            <span>Congrats! Your offer has been created.</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar1" top color="red" :timeout="10000">
            <span>{{message1}}</span> 
            <v-btn text color="white" @click="snackbar1 = false">Close</v-btn>
        </v-snackbar>
        
        
        <v-row>
            <v-col cols="12" sm="6" md="8">
                <v-card class="px-12 mt-3" id="login" flat>
                <v-toolbar flat height="30" class="mb-n4 mt-5">
                    <h5>SET DISCOUNT RATE:</h5>
                    <v-spacer></v-spacer>
                    <h4 class="green--text">{{slider}}%</h4>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                </v-toolbar>
                   <v-card-text>
                        <v-row>
                            <v-col class="pr-4">
                            <v-slider
                                v-model="slider"
                                class="align-center"
                                :max="max"
                                :min="min"
                                hide-details
                                color="green"
                                track-color="green"
                            >
                            </v-slider>
                            <v-subheader class="ma-0 pa-0 black--text">Discount<strong class="green--text">(%)</strong>:</v-subheader>
                            <v-text-field
                                v-model="slider"
                                class="mt-0 pt-0"
                                single-line
                                type="number"
                                style="width: 100px"
                                autofocus
                                outlined
                                dense
                                color="green"
                                min="0"
                                :max="max"
                                oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                            ></v-text-field>
                            <!-- <div>%</div> -->
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-text>
                        <h3 class="font-weight-bold black--text">ADD EXTRA DETAILS</h3>
                        
                    </v-card-text>
                    <v-card-actions>
                        <v-checkbox v-model="taxPaid" color="green" class=""></v-checkbox>

                        <v-btn style="border:1px solid teal" text class="mr-5" @click="taxPaid=!taxPaid">TAX PAID</v-btn>
                        <v-checkbox v-model="primeOnly" color="green" class=""></v-checkbox>
                        <v-btn style="border:1px solid teal" text @click="primeOnly=!primeOnly">ONLY PRIME</v-btn>
                    </v-card-actions>
                        

                </v-card>
            </v-col>
            <v-col cols="12" md="4" sm="6">
                <v-card class="black--text mx-auto py-3 px-4" max-width="400px">
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="ma-0 pa-0">Original</v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-text class="black--text text-right font-weight-bold">{{price}} USD</v-card-text>
                    </v-system-bar>
                    <v-divider></v-divider>
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="ma-0 pa-0">Discount</v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-text class="black--text text-right font-weight-bold">{{discount}} USD</v-card-text>
                    </v-system-bar>
                    <v-divider></v-divider>
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="ma-0 pa-0">Bitshopy Fee</v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-text class="black--text text-right font-weight-bold">{{bitshopyFee}} USD</v-card-text>
                    </v-system-bar>
                    <v-divider></v-divider>
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="ma-0 pa-0">Total Pay</v-card-text>
                        <v-spacer></v-spacer>
                        <v-card-text class="black--text text-right font-weight-bold">{{total}} USD</v-card-text>
                    </v-system-bar>
                    <v-system-bar class="" color="white">
                        <v-card-text class="orange--text text-right font-weight-bold"> {{computeBtc}} BTC</v-card-text>
                    </v-system-bar>
                    <v-divider></v-divider>
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="ma-0 pa-0">Include Shipping Fee</v-card-text>
                        <v-spacer></v-spacer>
                        <input type="number" v-model="shippingFee" min="0" max="100" style="border:1px solid black;border-radius:5px" placeholder="0" class="px-2" autofocus oninput="if(Number(this.value) < 0) this.value = 0"> <span class="black--text font-weight-bold ml-1">USD</span>
                    </v-system-bar>
                    <v-subheader class="mt-n7">(Optional)</v-subheader>
                    <v-divider></v-divider>
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="ma-0 pa-0">Include Tax Fee</v-card-text>
                        <v-spacer></v-spacer>
                        <input type="number" v-model="taxFee" min="0" max="100" style="border:1px solid black; border-radius:5px" placeholder="0" class="px-2" autofocus oninput="if(Number(this.value) < 0) this.value = 0"> <span class="black--text font-weight-bold ml-1">USD</span>
                    </v-system-bar>
                    <v-subheader class="mt-n7">(Optional)</v-subheader>
                    <v-divider></v-divider>
                    <v-system-bar color="white" class="py-5">
                        <v-card-text class="text-center black--text">SAVED &nbsp;&nbsp;<span class="green--text font-weight-bold"> {{saved}} USD</span></v-card-text>
                    </v-system-bar>
                    
                    

                    <div class="text-center mt-10">
                        <v-btn large dark rounded color="success" :loading="loading" class="heading mt-n11" @click="createOffer()">
                            Create Offer
                        </v-btn>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        
    </v-container>
</template>
<script>
export default {
    components:{
    },
    name:'SetDiscountRate',
    data(){
        return{
            min: 1,
            max: null,
            slider: 0,
            price: 0.0,
            shippingFee:"",
            taxFee:"",
            dialog:false,
            minPrice: null,
            maxPrice: null,
            username:'',
            snackbar:false,
            snackbar1:false,
            loading:false,
            taxPaid:false,
            primeOnly:false,
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            message1:'',
        }
    },
    computed:{
        discount(){
            const discountRate = parseFloat(this.slider/100)*parseFloat(this.price)
            return discountRate.toFixed(2) 
        },
        bitshopyFee(){
            const bitshopFee = 0.001*parseFloat(this.price)
            return bitshopFee
        },
        
        total(){
            let ship;
            let tax;
            if(this.shippingFee===""){ship=0}else{ship=this.shippingFee}
            if(this.taxFee===""){tax=0}else{tax= this.taxFee}
            const sum = parseFloat(this.price)-(parseFloat(this.slider/100)*parseFloat(this.price)) + (0.001*parseFloat(this.price) + parseFloat(ship) + parseFloat(tax))
            return sum.toFixed(2)
        },
        saved(){
            const safe = parseFloat(this.slider/100)*parseFloat(this.price)
            return safe.toFixed(2)
        },
        BtcRate(){
            return this.$store.state.offer.BtcRate
        },
        computeBtc(){
            let ship;
            let tax;
            if(this.shippingFee===""){ship=0}else{ship=this.shippingFee}
            if(this.taxFee===""){tax=0}else{tax= this.taxFee}
            const sum = parseFloat(this.price)-(parseFloat(this.slider/100)*parseFloat(this.price)) + (0.001*parseFloat(this.price) + parseFloat(ship) + parseFloat(tax))
            const btc = parseFloat(sum/this.BtcRate)
            return btc.toFixed(8)
        }

    },
    methods:{
        
        inputcheck(event){
            const value = event
            if (value>this.max) {
                this.$forceUpdate()
            }
        },
        inputcheck2(event){
            const value = event
            if (value<0) {
                this.$forceUpdate()
            }
        },
        createOffer(){
            let pocket = this.$store.state.auth.logindetails.walletBalanceUsd
            if(parseFloat(pocket)>parseFloat(this.total)){
                this.loading = true
                this.$store.dispatch("CreateOfferFinal", {
                "shopperId": this.$store.state.auth.logindetails.id,
                "savedFee": this.saved,
                "taxPaid": this.taxPaid,
                "onlyPrime": this.primeOnly,
                "bitshopyFee": this.bitshopyFee,
                "totalPay": this.total,
                "originalTotalPrice": this.price,
                "discount": this.slider,
                "noOfItems": this.$store.state.wishlist.WishListDetails.wishlistItems.length,
                "wishlistUrl": this.$store.state.wishlist.WishListUrl,
                "url": this.$store.state.wishlist.WishListDetails.url,
                "country": this.$store.state.wishlist.WishListDetails.country,
                "wishlistItems": this.$store.state.wishlist.WishListDetails.wishlistItems,
                "shippingFee": this.shippingFee,
                "taxFee": this.taxFee,
                "total": this.total
                })
                .then((success)=>{
                    this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                    console.log(success)
                    this.loading = false
                    this.snackbar = true
                    this.$router.push('/orders')

                })
                .catch((error)=>{
                    let msg = error.response.data.message
                    this.message1=msg.toUpperCase()
                    this.loading = false
                    this.snackbar1 = true
                    
                    
                    
                    
                });
            }else{
                this.message1 = "YOU DO NOT HAVE SUFFICIENT BALANCE FOR THIS TRANSCTION"
                this.snackbar1 = true
            }
            
        },
        calcTotal(){
            alert(this.shippingFee)
            if(this.shippingFee===''){this.shippingFee=0}
            this.total = parseFloat(this.total) + parseFloat(this.shippingFee)
            const sum = parseFloat(this.total) 
            const btc = parseFloat(sum/this.BtcRate)
            alert(this.computeBtc)
            this.computeBtc = btc
        },
        calcTotal2(){
            if(this.taxFee===''){this.taxFee=0}
            this.total = parseFloat(this.total) + parseFloat(this.taxFee)
            const sum = parseFloat(this.total)
            const btc = parseFloat(sum/this.BtcRate)
            this.computeBtc = btc

        }
        
    },
    created(){
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
        const price = parseFloat(this.$store.state.wishlist.WishListDetails.totalItemAmount)
        const minOffer = parseFloat(this.$store.state.auth.logindetails.minimumOfferPrice)  
        this.minPrice = minOffer
        const maxOffer = parseFloat(this.$store.state.auth.logindetails.maximumOfferPrice)  
        this.maxPrice = maxOffer
        const username = this.$store.state.auth.logindetails.username  
        this.username = username.toUpperCase()
        if((price>=minOffer)&(price<=maxOffer)){
            this.price = price
        }else{
            this.dialog = true
        }


        const maxDiscount = parseInt(this.$store.state.auth.logindetails.maximumDiscountAsShopper)
        this.slider = maxDiscount
        this.max = maxDiscount

        this.$store.dispatch("GetBtcRate")
        .then(()=>{
            
        })
        .catch((error)=>{
            console.log(error);
        })
    }
    
}
</script>
<style  scoped>
   
</style>